import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'monthsToYear'
})
export class SecondToYearMonthDaysPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var returnString = "";
    var months = value % 12;
    var years = Math.floor(value / 12);
    var anio = years > 1 ? "años" : "año";
    var mes = months > 1 ? "meses" : "mes";
    if (years > 0) {
      returnString = years + " " + anio;
    }
    if (months > 0) {
      if (returnString.length == 0) {
        returnString = months + " " + mes;
      } else {
        returnString += " y " + months + " " + mes;
      }
    }

    if (returnString.length == 0) {
      returnString = "0 meses";
    }

    return returnString;
  }

}
